export default "__VITE_ASSET__0bdfdccc__"